<!-- APP ROOT -->

<mat-drawer-container class="wh-content-container" autosize>
  <div class="wh-main-content">
    <router-outlet></router-outlet>
  </div>

  <mat-drawer position="end" #mainDrawer class="wh-ai-drawer" mode="side">
    @if (aiStore.isAiActive()) {
      <workheld-ai />
    }
  </mat-drawer>
</mat-drawer-container>
